// act as width container component for all components
const Section = ({ children, classNames = "", wrapperClassNames = "", id }) => (
  <div className={`section-wrapper ${wrapperClassNames}`} id={id}>
    <div className={`section ${classNames}`}>
      {children}
    </div>
  </div>
)

export default Section;